// extracted by mini-css-extract-plugin
export default {"btn-primary":"_textinput_btn-primary__SpvdX","input":"_textinput_input__NDzXV","inline":"_textinput_inline__TpvMh","medium":"_textinput_medium__Iy1Is"};